import React from "react"
import { Link } from "react-router-dom"

export default function Recruiters() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block mb-6 px-4 py-2 bg-blue-100 text-blue-900 rounded-full text-sm font-medium">
            🔜 Recruiter Portal Opening March 1, 2026
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Recruit with Nursing Hive
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Clinician-led matching with verified nurses across multiple destinations.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <div className="mb-12 text-center">
            <p className="text-lg text-gray-700">
              <strong>Coming March 1, 2026:</strong> The Nursing Hive recruiter portal opens for verified healthcare recruiters. Apply now for early access.
            </p>
          </div>

          {/* Why Partner Section */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Why partner with us</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="w-6 h-6 text-teal-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700">Verified nurse profiles with document checks</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-teal-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700">Ethical, compliance-first recruiting</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-teal-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700">Focused routes: USA, UK/Ireland, GCC, Canada</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-teal-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700">Direct messaging with interested nurses</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-teal-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700">Transparent, performance-based pricing (shared on approval)</span>
              </li>
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/recruiters/apply"
              className="inline-flex items-center justify-center px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl"
            >
              Apply for Early Access
            </Link>
            <a
              href="mailto:hello@nursinghive.com"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:border-gray-400 transition-colors"
            >
              Contact Us
            </a>
          </div>

          {/* Next Steps */}
          <div className="bg-gray-50 rounded-xl p-8 text-center">
            <p className="text-gray-700 mb-4">
              <strong>Next Steps:</strong>
            </p>
            <ol className="text-left max-w-md mx-auto space-y-2 text-gray-600">
              <li>1) Apply for early access (5 minutes)</li>
              <li>2) Verification call with our team</li>
              <li>3) Get portal access on March 1, 2026</li>
              <li>4) Start recruiting verified nurses immediately</li>
            </ol>
          </div>
        </div>
      </section>
    </div>
  )
}
